import { queryOptions } from '@tanstack/react-query';

import { getTeamMemberQuery, getTeamMembersQuery } from './shared';

export const getTeamMemberQueryOption = (id: string) => queryOptions(getTeamMemberQuery(id));
export const getTeamMembersQueryOptions = () => queryOptions(getTeamMembersQuery());
